// Order fulfillment steps
export enum ORDER_STEP {
  ORDER_PERSONAL_STEP = 'orderPersonalStep',
  ORDER_ADDRESS_STEP = 'orderAddressStep',
  ORDER_CROSS_SELL_STEP = 'orderCrossSellStep',
  ORDER_PAYMENT_STEP = 'orderPaymentStep',
  ORDER_CONFIRMATION_STEP = 'orderConfirmationStep',
}

// Order fulfillment flow variants
export const ORDER_REGULAR_FLOW_STEP_INDEX = {
  [ORDER_STEP.ORDER_PERSONAL_STEP]: 1,
  [ORDER_STEP.ORDER_ADDRESS_STEP]: 2,
  [ORDER_STEP.ORDER_PAYMENT_STEP]: 3,
  [ORDER_STEP.ORDER_CONFIRMATION_STEP]: 4,
  [ORDER_STEP.ORDER_CROSS_SELL_STEP]: -1,
};

export const ORDER_CROSS_SELL_FLOW_STEP_INDEX = {
  [ORDER_STEP.ORDER_PERSONAL_STEP]: 1,
  [ORDER_STEP.ORDER_ADDRESS_STEP]: 2,
  [ORDER_STEP.ORDER_CROSS_SELL_STEP]: 3,
  [ORDER_STEP.ORDER_PAYMENT_STEP]: 4,
  [ORDER_STEP.ORDER_CONFIRMATION_STEP]: 5,
};
